module.exports = __webpack_public_path__ + "img/15_20.56c9f57c.png";